import { useEffect } from 'react';
import { authApi } from '@/features/auth/api/auth.api';
import { AuthLoadingFallback } from '@/features/auth/components/AuthLoadingFallback';
import { useAuthStore } from '@/store/auth';
import { STORAGE_KEYS } from '@/utils/constants';

export function AuthBootstrap({ children }: { children: React.ReactNode }) {
  const setMe = useAuthStore((s) => s.setMe);
  const setInitializing = useAuthStore((s) => s.setInitializing);
  const logout = useAuthStore((s) => s.logout);
  const isInitializing = useAuthStore((s) => s.isInitializing);

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    if (!token) {
      setInitializing(false);
      return;
    }

    authApi
      .getMe()
      .then(setMe)
      .catch(() => {
        logout();
      })
      .finally(() => {
        setInitializing(false);
      });
  }, [setMe, setInitializing, logout]);

  if (isInitializing) {
    return <AuthLoadingFallback />;
  }

  return <>{children}</>;
}
